import {
  UI_COLOR_PRIMARY,
  UI_COLOR_PRIMARY_HOVER,
  UI_COLOR_PRIMARY_SOFT,
  UI_COLOR_PRIMARY_SOFT_BORDER,
  UI_COLOR_WHITE
} from '../../constants/uiColors'

export const REPORT_PRIMARY_ACCENT = UI_COLOR_PRIMARY
export const REPORT_PRIMARY_ACCENT_HOVER = UI_COLOR_PRIMARY_HOVER
export const REPORT_PRIMARY_ACCENT_BORDER_SOFT = UI_COLOR_PRIMARY_SOFT_BORDER
export const REPORT_PRIMARY_ACCENT_SOFT_BG = UI_COLOR_PRIMARY_SOFT

export const REPORT_RANGE_SEPARATOR_BG = 'rgba(0, 0, 0, 0.22)'

export const REPORT_PRIMARY_BUTTON_TEXT = UI_COLOR_WHITE
export const REPORT_PRIMARY_BUTTON_SHADOW = '0 2px 4px rgba(0, 0, 0, 0.14)'
export const REPORT_PRIMARY_BUTTON_SHADOW_HOVER = '0 2px 6px rgba(0, 0, 0, 0.18)'
